export default __webpack_public_path__ + "static/media/min-button.446f1821.png";